export const SEARCH_FIELD_NAME = 'headerSearchField';
export const SEARCH_DATA_TEST_ID = 'search_input';
export const SEARCH_INPUT_HEIGHT = '76px';
export const MAX_SEARCH_CONTENT_ITEMS = 5;
export const CATEGORY_STRING_KEY = '{categoryString}';
export const DEBOUNCE_TIME = 300;
export const MIN_SYMBOLS_TO_SEARCH = 2;
export const MAX_SYMBOLS_TO_SEARCH = 100;
export const SUGGESTED_QUERY_PARAMETER = '_br_psugg_q';
